
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M16.4 32.78H1V3.88h31.08v15.71M8.15.4v6.97M16.55.4v6.97M24.95.4v6.97M1.35 11.49h30.38M36.58 27.93a10.69 10.69 0 10-.66 3.68"}}),_c('path',{attrs:{"d":"M28.17 25.51a2.25 2.25 0 00-2.4-2.15 2.19 2.19 0 00-2.39 2.07 1.92 1.92 0 00.73 1.65 6.43 6.43 0 002.29.92 2.23 2.23 0 01-.47 4.44 2.4 2.4 0 01-2.55-2.15M25.85 22.72v-1.29M25.85 34.35v-1.83M39 24.27l-2.4 3.44-3.44-2.39","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    